import { render, staticRenderFns } from "./RoyImage.vue?vue&type=template&id=6092240c&"
import script from "./RoyImage.vue?vue&type=script&lang=js&"
export * from "./RoyImage.vue?vue&type=script&lang=js&"
import style0 from "./RoyImage.vue?vue&type=style&index=0&id=6092240c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports